import React from 'react';

import { Button, LinkButton, Modal } from '@dutchie/backoffice-ui-library';

import { BulkAction } from '../constants';
import { getConfirmModalBodyText } from '../util';

import { ModalBodyText, ModalButtonWrapper } from './styled';

type ConfirmModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  pendingAction: BulkAction;
};

export function ConfirmModal({
  onClose,
  onConfirm,
  pendingAction,
}: ConfirmModalProps) {
  return (
    <Modal
      $width="522px"
      footer={
        <ModalButtonWrapper>
          <LinkButton onClick={onClose} text="Cancel" />
          <Button onClick={onConfirm} buttonLabel="Confirm" />
        </ModalButtonWrapper>
      }
      onClose={onClose}
      open
      title="Confirm data sharing status change"
    >
      <ModalBodyText>{getConfirmModalBodyText(pendingAction)}</ModalBodyText>
    </Modal>
  );
}
